import { MutableRefObject } from "react";

export const CULTIVAR_INIT_STEP = "CULTIVAR";

export interface CultivarFormProps {
  supplierId: string;
  ingredientId: string;
  farmGateId: string;
  ownerId: string;
  sourceId: string;
  lockStatus?: boolean;
  nodeItem: any;
  updateDrawingNode: (
    node: any,
    farmGateName?: string,
    options?: { closeModal?: boolean }
  ) => void;
  setNodeItem: (value: any) => void;
}

export interface FarmGateFormValues {
  farmGateName: string;
}

export interface CultivationDataValues {
  dataType?: string;
  produceType?: string;
  farmingType?: string;
  farmingField?: string;
  region?: string;
  latitude?: number | null;
  longitude?: number | null;
  produceCultivar?: string;
}

export interface FieldDataValues {
  yield?: number | string;
  growthArea?: number | string;
  harvestYear?: number | string;
  harvestSeason?: string;
}

export interface CultivationFieldSectionData {
  fertilizerList: Array<{ id: number | string; fertilizerQuantity: number | string }>;
  pesticideList: Array<{ id: number | string; pesticideQuantity: number | string }>;
  irrigations: any[];
  fuelUse: any[];
  landUsage: any[];
}

export interface CultivarSectionRefHandles {
  getCultivationData?: () => Promise<CultivationDataValues | null>;
  getFieldData?: () => Promise<FieldDataValues | null>;
  getFretilizerData?: () => any[];
  getPesticideData?: () => any[];
  getIrrigationData?: () => any[];
  getFuelUse?: () => any[];
  getLandUseData?: () => any[];
  getLanduseStatus?: () => string;
}

export interface CultivarSectionRefs {
  cultivation: MutableRefObject<CultivarSectionRefHandles | null>;
  field: MutableRefObject<CultivarSectionRefHandles | null>;
  fertilizer: MutableRefObject<CultivarSectionRefHandles | null>;
  pesticide: MutableRefObject<CultivarSectionRefHandles | null>;
  irrigation: MutableRefObject<CultivarSectionRefHandles | null>;
  fuelUse: MutableRefObject<CultivarSectionRefHandles | null>;
  landUse: MutableRefObject<CultivarSectionRefHandles | null>;
}

export interface SaveDocumentDataHandle {
  saveDocumentAndNote(id: string): Promise<void>;
  deleteComment(): void;
}

export interface UpdateDrawingNodeOptions {
  closeModal?: boolean;
}
